import { Component, ElementRef, Input, OnInit, OnChanges, OnDestroy, ViewChild, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { HaloCustomLoaderService,HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { AverageByEquipment, AverageByEquipmentModel, EquipmentsAverageByChartData, EquipmentsAverageByDayChartModel, EquipmentsChartModelItem, EquipmentsChartModelSeries, ReportMapEntry, UtilizationFilter } from 'src/app/post-login/services/stats.model';
import { StatsService } from 'src/app/post-login/services/stats.service';
export var multi = [];
var _this: any;
@Component({
  selector: 'app-average-by-equipment',
  templateUrl: './average-by-equipment.component.html',
  styleUrls: ['./average-by-equipment.component.scss']
})
export class AverageByEquipmentComponent implements OnInit {
  multi: any[];
  tooltip1 = { data: {}, type: AverageByEquipment.DISTANCE };
  tooltip2 = { data: {}, type: AverageByEquipment.DISTANCE };
  tooltip3 = { data: {}, type: AverageByEquipment.DISTANCE };
  colorSchemeArray: string[] = [];
  isAllDisabled = true;
  rowData: AverageByEquipmentModel;
  isCardioSelecet: boolean | undefined = undefined;
  AverageByEquipment = AverageByEquipment;
  dataType: AverageByEquipment = AverageByEquipment.HOURS;

  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  trimXAxisTicks: boolean = false;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = false;
  yAxisLabel: string = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('HOURS'));
  timeline: boolean = true;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  isInsigniaExist = false;
  insigniaCount = '0';
  paramName = AverageByEquipment.HOURS;
  private averageHours = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('HOURS'));
  private averageDistance = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('DISTANCE'));
  private averageWorkout = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('WORKOUTS'));
  private averageWeight = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('WEIGHTS'));
  private sub = new Subscription();
  public previousWidthOfResizedDiv: number = 0;
  colorScheme = {
    domain: this.colorSchemeArray
  };
  rootScopeData: RootScopeDeclare;
  unitDistance: string | undefined = '';
  unitWeight: string | undefined = '';
  @Input() filterData: UtilizationFilter[] = []
  @Input() productMixData: any;
  @Input() equipmentColorMap: any[];
  @Input() dateFrom: Date;
  @Input() dateTo: Date;
  @Output() filterChanged = new EventEmitter<UtilizationFilter[]>();
  @ViewChild('resizedDiv') resizedDiv: ElementRef;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  constructor(
    private _subscriptionService: StatsService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private rootScopeService: RootScopeService,
    private haloCustomLoaderService: HaloCustomLoaderService,
  ) {
    Object.assign(this, { multi });
    _this = this;
    this.getRootScopeData();
  }

  async ngOnInit() {
    const facilitySub = this._facilityService.selectedFacilitySource.subscribe(async (res) => {
      if (res.summary.facilityRights.stats !== 'false' && res.summary.userRights.stats !== 'H') {
        this.isInsigniaExist = false;
        this.insigniaCount = '0';
        this.filterData = [];
        this.filterChanged.emit([]);
        this.getData(true);
      }
    });
    this.getData(false);
    this.sub.add(facilitySub);

  }

  getRootScopeData(): void {
    const rootScopeSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData
      this.unitDistance = this.rootScopeData.preferredUnit === 'I' ? 'Mi' : 'Km';
      this.unitWeight = this.rootScopeData.preferredUnit ===  'I' ? 'Lbs' : 'Kgs';
    });
    this.sub.add(rootScopeSub);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.productMixData && changes.productMixData.currentValue && changes.productMixData.currentValue !== changes.productMixData.previousValue) {
      this.insigniaCount = this.productMixData.productMix.find((val: any) => val.activityId === '10001') ? this.productMixData.productMix.find((val: any) => val.activityId === '10001').noOfEquips : '0';
      this.isInsigniaExist = this.productMixData.productMix.find((val: any) => val.activityId === '10001') ? true : false;
      if (this.rowData) {
        if (!(this.rowData.statisticsData.find(val => val.activityId === '10001') ? true : false) && this.isInsigniaExist && !this.customLoaderIsLoading) {
          let tmpData = this.loadDefaultInsigniaData();
          this.rowData.statisticsData.push(tmpData as any);
          this.rowData.totalEquipmentCount += Number(this.insigniaCount);
          this.updateFilterData(this.rowData);
          this.confiruChart(this.rowData);
          let ind = this.filterData.findIndex(x => (x.type === 10001));
          if (ind === -1) {
            this.filterData.push({ value: false, colour: '#CC99CC', type: 10001, count: Number(this.insigniaCount) });
            let allFilter = this.filterData.find(x => x.type === -1);
            if (allFilter) {
              allFilter.count += Number(this.insigniaCount);
            }
            this.filterChanged.emit(this.filterData);
          }
        } else {
          for (let i = this.filterData.length - 1; i >= 0; i--) {
            let ind = this.filterData.findIndex(x => (x.type === 10001));
            if (ind != -1) {
              this.filterData.splice(ind, 1);
            }
          }
          this.filterChanged.emit(this.filterData);
        }
      }
    }
    if (changes.dateFrom && changes.dateFrom.currentValue && changes.dateFrom.previousValue && (changes.dateFrom.currentValue.getMonth() !== changes.dateFrom.previousValue.getMonth() || changes.dateFrom.currentValue.getDate() !== changes.dateFrom.previousValue.getDate())
      || changes.dateTo && changes.dateTo.currentValue && changes.dateTo.previousValue && (changes.dateTo.currentValue.getMonth() !== changes.dateTo.previousValue.getMonth() || changes.dateTo.currentValue.getDate() !== changes.dateTo.previousValue.getDate())) {
      this.dateFrom = changes.dateFrom.currentValue;
      this.dateTo = changes.dateTo.currentValue;
      this.getData(false);
    }
  }

  getData(newFacility: boolean) {
    this.customLoaderIsLoading = true;
    const from = (this.dateFrom.getMonth() + 1) + '/' + this.dateFrom.getDate() + '/' + this.dateFrom.getFullYear();
    const to = (this.dateTo.getMonth() + 1) + '/' + this.dateTo.getDate() + '/' + this.dateTo.getFullYear();
    const averageByEquipmentSub = this._subscriptionService.getAverageByEquipment(this._facilityService.selectedFacilityId(), from, to, Intl.DateTimeFormat().resolvedOptions().timeZone).subscribe((data: AverageByEquipmentModel) => {
      this.customLoaderIsLoading = false;
      this.updateFilterData(data);
      this.rowData = data;
      if (!(data.statisticsData?.find(val => val.activityId === '10001') ? true : false) && this.isInsigniaExist) {
        let tmpData = this.loadDefaultInsigniaData();
        if(!this.rowData.statisticsData) {
          this.rowData.statisticsData = [];
        }
        this.rowData.statisticsData.push(tmpData as any);
        this.rowData.totalEquipmentCount = this.rowData.totalEquipmentCount;
      }
      this.getChartData((<boolean> !this.filterData.find(x => x.type === -1)?.value) && !newFacility);
      this.confiruChart(data);
    },err => {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
    });
    this.sub.add(averageByEquipmentSub);
  }

  updateFilterData(data: AverageByEquipmentModel) {
    this.filterData.forEach(item => {
      let i = data.statisticsData?.findIndex(x => Number(x.activityId) === item.type);
      if(i === -1) {
        if(item.type === 10001 && !this.isInsigniaExist) {
          this.filterData.splice(i, 1);
        }
        if(item.type !== 10001 && item.type !== -1) {
          this.filterData.splice(i, 1);
        }
      }
    });
    if(this.isInsigniaExist && !this.filterData.find(x => x.type === 10001)) {
      this.filterData.push({ value: false, colour: '#CC99CC', type: Number('10001'), count: Number(this.insigniaCount) });
    }
    this.filterChanged.emit(this.filterData);
  }

  loadDefaultInsigniaData() {
    let data = {
      "activityId": "10001",
      "statsData": {
        "avgDistance": "0.0",
        "avgHours": "0.0",
        "avgWorkouts": "0.0",
        "dataCount": this.insigniaCount,
        "preferredUnit": "I",
        "totalDistance": "0.0",
        "totalMinutes": "0.0",
        "totalWorkouts": "0.0"
      }
    }
    return data;
  }

  switchData(type: AverageByEquipment) {
    this.dataType = type;
    switch (type) {
      case AverageByEquipment.HOURS:
        this.yAxisLabel = this.averageHours;
        break;
      case AverageByEquipment.DISTANCE:
        this.yAxisLabel = this.averageDistance;
        break;
      case AverageByEquipment.WORKOUT:
        this.yAxisLabel = this.averageWorkout;
        break;
      case AverageByEquipment.WEIGHT:
        this.yAxisLabel = this.averageWeight;
        break;
    }
    this.getChartData(true);
  }

  confiruChart(data: AverageByEquipmentModel) {
    var total = 0;
    this.colorScheme.domain = [];
    if (this.filterData && this.filterData.length > 0) {
      data.statisticsData.forEach(eq => {
        if ((this.filterData.find(x => x.type === Number(eq.activityId) && x.value === true) && Number(eq.statsData.dataCount) > 0) || this.filterData[0].value === true) {
          let c = this.equipmentColorMap.find(x => x.id == eq.activityId);
          this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
          total += Number(Number(eq.statsData.dataCount));
        }
        let filterItemIndex = this.filterData.findIndex(x => x.type === Number(eq.activityId));
        if (filterItemIndex == -1 && Number(eq.statsData.dataCount) > 0) {
          let c = this.equipmentColorMap.find(x => x.id == eq.activityId);
          this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
          this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.activityId), count: Number(eq.statsData.dataCount) });
        } else {
          this.filterData[filterItemIndex].count = Number(eq.statsData.dataCount);
        }
      });
    } else {
      this.colorScheme.domain = [];
      data.statisticsData.forEach(eq => {
        if (!this.filterData.find(x => x.type === Number(eq.activityId)) && Number(eq.statsData.dataCount) > 0) {
          let c = this.equipmentColorMap.find(x => x.id == eq.activityId);
          this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
          this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.activityId), count: Number(eq.statsData.dataCount) });
          total += Number(eq.statsData.dataCount);
        }
      });
    }
    let insigniaIndex = this.filterData.findIndex(f => f.type === 10001);
    if(data.statisticsData.find(val => val.activityId === '10001') && this.isInsigniaExist && insigniaIndex == -1){
      let c = this.equipmentColorMap.find(x => x.id == '10001');
      this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number('10001'), count: Number(this.insigniaCount) });
      this.colorScheme.domain.push(c && c.colour ? c.colour : c.colour);
    }
    // move insignia data to the last in array
    if(insigniaIndex != -1 && insigniaIndex != this.filterData.length-1) {
      let tmp = this.filterData[insigniaIndex];
      this.filterData.splice(insigniaIndex, 1);
      this.filterData.push(tmp);
      this.colorScheme.domain.push(this.equipmentColorMap.find(x => x.id == '10001').colour);
    } else if(insigniaIndex == 0 && this.filterData[0].type === 10001){
      this.colorScheme.domain.push(this.equipmentColorMap.find(x => x.id == '10001').colour);
    }
    let all: number = this.filterData.findIndex(x => x.type === -1);
    let val =  this.filterData.findIndex(x => x.value == true && x.type != -1) == -1;
    this.isAllDisabled = val;
    let newItem = { value: val, colour: '#ccc', type: -1, count: Number(this.rowData.totalEquipmentCount) }
    if (all == -1) {
      this.filterData = [newItem].concat(this.filterData);
    } else {
      this.filterData[all] = newItem;
    }
    this.filterChanged.emit(this.filterData);
    this.isCardio();
  }

  isCardio() {
    if(this.isInsigniaExist) {
      if(this.filterData[0].value) {
        this.isCardioSelecet = this.filterData.findIndex(x => (x.type !== 10001) && (x.type !== -1)) !== -1 ? undefined : false;
      } else if(this.filterData.find(x => x.type === 10001)?.value && this.filterData.findIndex(x => x.value && x.type !== 10001) === -1) {
        this.isCardioSelecet = false;
      } else if(!this.filterData.find(x => x.type === 10001)?.value && this.filterData.findIndex(x => x.value && x.type !== 10001) !== -1) {
        this.isCardioSelecet = true;
      } else {
        this.isCardioSelecet = undefined;
      }
    } else {
      this.isCardioSelecet = true;
    }
  }

  changeSelectAll(item: UtilizationFilter) {
    let i = this.filterData.findIndex(x => x.type == item.type);
    this.filterData[i].value = !this.filterData[i].value;
    if (i = 0 && this.filterData[i].value) {
      this.isAllDisabled = true;
      this.filterData.forEach(i => {
        i.type != -1 ? i.value = false : i.value;
      });
    } else {
      this.isAllDisabled = false;
      this.filterData[0].value = false;
    }
    if (item.type == -1) {
      this.filterData.forEach(i => {
        i.type != -1 ? i.value = false : i.value;
      });
    }

    if (this.filterData.find(x => x.value && x.type != -1) == undefined) {
      this.filterData[0].value = true;
      this.isAllDisabled = true;
      this.colorScheme.domain = [];
      let tmp: any[] = [];
      this.filterData.forEach(item => {
        if (item.type != -1) {
          let tmpMulti = new EquipmentsAverageByChartData(this.rowData, this.dataType).equipmentsUtilizationChartModel;
          tmp.push(tmpMulti.find((x: EquipmentsChartModelSeries) => Number(x.name) == item.type));
          this.colorScheme.domain.push(item.colour);
        }
      })
      this.multi = tmp;
    } else {
      this.filterData[0].value = false;
      let tmp: any[] = [];
      this.colorScheme.domain = [];
      this.filterData.forEach(item => {
        if (item.value) {
          let tmpMulti = new EquipmentsAverageByChartData(this.rowData, this.dataType).equipmentsUtilizationChartModel;
          tmp.push(tmpMulti.find((x: EquipmentsChartModelSeries) => Number(x.name) == item.type));
          this.colorScheme.domain.push(item.colour);
        }
      })
      this.multi = tmp;
    }
    this.filterChanged.emit(this.filterData);
    this.isCardio();
  }

  getChartData(tabSwitch: boolean) {
    switch (this.dataType) {
      case AverageByEquipment.HOURS:
        this.paramName = AverageByEquipment.HOURS;
        this.tooltip1.type = AverageByEquipment.DISTANCE;
        this.tooltip2.type = AverageByEquipment.WORKOUT;
        this.tooltip3.type = AverageByEquipment.WEIGHT;
        break;
      case AverageByEquipment.DISTANCE:
        this.paramName = AverageByEquipment.DISTANCE;
        this.tooltip1.type = AverageByEquipment.HOURS;
        this.tooltip2.type = AverageByEquipment.WORKOUT;
        this.tooltip3.type = AverageByEquipment.WEIGHT;
        break;
      case AverageByEquipment.WORKOUT:
        this.paramName = AverageByEquipment.WORKOUT;
        this.tooltip1.type = AverageByEquipment.HOURS;
        this.tooltip2.type = AverageByEquipment.DISTANCE;
        this.tooltip3.type = AverageByEquipment.WEIGHT;
        break;
      case AverageByEquipment.WEIGHT:
        this.paramName = AverageByEquipment.WEIGHT;
        this.tooltip1.type = AverageByEquipment.HOURS;
        this.tooltip2.type = AverageByEquipment.DISTANCE;
        this.tooltip3.type = AverageByEquipment.WORKOUT;
        break;
    }
    let tmpMulti = new EquipmentsAverageByChartData(this.rowData, this.dataType).equipmentsUtilizationChartModel;
    if (tabSwitch && this.filterData && this.filterData.length > 0 && !this.filterData[0].value) {
      for (let i = tmpMulti.length - 1; i >= 0; i--) {
        let ind = this.filterData.findIndex(x => (x.type === Number(tmpMulti[i].name)) && x.value);
        if (ind === -1) {
          tmpMulti.splice(i, 1);
        }
      }
    }
    this.multi = [];
    setTimeout(() => {     this.multi = tmpMulti; });

    this.tooltip1.data = new EquipmentsAverageByChartData(this.rowData, this.tooltip1.type).equipmentsUtilizationChartModel;
    this.tooltip2.data = new EquipmentsAverageByChartData(this.rowData, this.tooltip2.type).equipmentsUtilizationChartModel;
    this.tooltip3.data = new EquipmentsAverageByChartData(this.rowData, this.tooltip3.type).equipmentsUtilizationChartModel;
  }

  ngAfterViewChecked() {
    if (this.resizedDiv != undefined) {
      if (this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth) {
        this.multi = [...this.multi]
      }
      this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
    }
  }

  count(model: any) {
    let index = this.multi.findIndex(x => x.name == model.name);
    return this.multi[index].count;
  }

  getValue(model: any, type: number) {
    let data: any;
    if (model.value!) {

    }
    if (this.dataType == AverageByEquipment.HOURS) {
      data = type == 2 ? this.tooltip1 : type == 3 ? this.tooltip2 : this.tooltip3;
    } else if (this.dataType == AverageByEquipment.DISTANCE) {
      data = type == 1 ? this.tooltip1 : type == 3 ? this.tooltip2 : this.tooltip3;
    } else if (this.dataType == AverageByEquipment.WORKOUT) {
      data = type == 1 ? this.tooltip1 : type == 2 ? this.tooltip2 : this.tooltip3;
    } else {
      data = type == 1 ? this.tooltip1 : type == 2 ? this.tooltip2 : this.tooltip3;
    }
    let index = this.multi.findIndex(x => x.name == model.name);
    const value = data && data.data && data.data.length > 0 ? data.data.find((x: { name: any; }) => x.name == model.name).value : undefined;
    let unit  = this.multi[index].preferredUnit === undefined ? this.unitWeight : this.multi[index].preferredUnit === 'I' ? 'Lbs' : 'Kgs';
    return  type === 4 ? value + ' ' + unit : value;
  }

  getCurrentTypeVal(model: any, type: number) {
    let val = this.rowData.statisticsData.find(x => x.activityId == model.name)
    switch (type) {
      case 2:
        return val?.statsData.avgDistance;
      case 3:
        return val?.statsData.avgWorkouts;
      case 4:
        return val?.statsData.avgWeights;
    }
    return '';
  }

  getTime(model: any) {
    let val = this.rowData.statisticsData.find(x => x.activityId == model.name)?.statsData.avgHours;
    let totalMinsVal = Number(val) * 60;
    let h = Math.floor(totalMinsVal / 60);
    let m = Math.round(totalMinsVal % 60).toString();
    return h + ":" + (m.length == 1 ? '0' + m : m);
  }

  axisFormat(val: any) {
    //hook for custom labels, have own scope we must use copy of this
    return _this.commonUtil.translateText('EQ.TYPE.' + val);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
